"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PgBytesInputException = void 0;
exports.pgBytes = pgBytes;
exports.toBuffer = toBuffer;
exports.toString = toString;
exports.toQueryObjectGTV = toQueryObjectGTV;
exports.ensureBuffer = ensureBuffer;
exports.ensureString = ensureString;
exports.checkGtvType = checkGtvType;
exports.rawGtxToGtx = rawGtxToGtx;
exports.rawGtxToRawGtxBody = rawGtxToRawGtxBody;
exports.checkGtxType = checkGtxType;
exports.removeDuplicateSigners = removeDuplicateSigners;
exports.matchRellErrorString = matchRellErrorString;
const buffer_1 = require("buffer");
const rawGtx_1 = require("./blockchainClient/validation/rawGtx");
const bufferUtils_1 = require("./utils/bufferUtils");
function pgBytes(buffer) {
    if (!buffer_1.Buffer.isBuffer(buffer)) {
        throw new PgBytesInputException(buffer);
    }
    return `\\x${buffer.toString("hex")}`;
}
/**
 * Converts hex string to Buffer
 * @param key: string
 * @returns {Buffer}
 */
function toBuffer(key) {
    return buffer_1.Buffer.from(key, "hex");
}
/**
 * Converts Buffer to hex string
 * @param buffer: Buffer
 * @returns {string}
 */
function toString(buffer) {
    return buffer.toString("hex").toUpperCase();
}
function toQueryObjectGTV(nameOrObject, queryArguments) {
    if (typeof nameOrObject === "string") {
        return [nameOrObject, Object.assign({}, queryArguments)];
    }
    else {
        const { name, args } = nameOrObject;
        return [name, args || {}];
    }
}
class PgBytesInputException extends Error {
    constructor(buffer) {
        super(`util.pgBytes expects a buffer, but got ${typeof buffer}`);
    }
}
exports.PgBytesInputException = PgBytesInputException;
function ensureBuffer(value) {
    if ((0, bufferUtils_1.isBuffer)(value)) {
        return value;
    }
    return toBuffer(value);
}
function ensureString(value) {
    if (typeof value === "string") {
        return value.toUpperCase();
    }
    else {
        return toString(value);
    }
}
function checkGtvType(value) {
    try {
        if (value == null) {
            return true;
        }
        if (buffer_1.Buffer.isBuffer(value)) {
            return true;
        }
        if (typeof value === "string" || typeof value === "bigint") {
            return true;
        }
        if (typeof value === "number") {
            if (!Number.isInteger(value)) {
                throw Error("User error: Only integers are supported");
            }
            return true;
        }
        if (Array.isArray(value)) {
            return value.every(item => checkGtvType(item));
        }
        if (typeof value === "object") {
            return Object.values(value).every(val => checkGtvType(val));
        }
    }
    catch (error) {
        throw new Error(`Failed to check type: ${error}`);
    }
    return false;
}
function rawGtxToGtx(rawGtx) {
    const rawGtxBody = rawGtx[0];
    const signatures = rawGtx[1];
    const gtxBody = {
        blockchainRid: rawGtxBody[0],
        operations: rawGtxBody[1].map((operation) => ({
            opName: operation[0],
            args: operation[1],
        })),
        signers: rawGtxBody[2],
    };
    return {
        blockchainRid: gtxBody.blockchainRid,
        operations: gtxBody.operations,
        signers: gtxBody.signers,
        signatures,
    };
}
function rawGtxToRawGtxBody(rawGtx) {
    return rawGtx[0];
}
function checkGtxType(value) {
    if (!(0, rawGtx_1.isRawGtx)(value))
        return false;
    try {
        rawGtxToGtx(value);
        return true;
    }
    catch (error) {
        return false;
    }
}
function removeDuplicateSigners(signers) {
    const signersAsString = [];
    signers.forEach(item => {
        const itemAsString = item.toString("hex");
        if (!signersAsString.includes(itemAsString)) {
            signersAsString.push(itemAsString);
        }
    });
    const result = [];
    signersAsString.forEach(item => {
        result.push(buffer_1.Buffer.from(item, "hex"));
    });
    return result;
}
function matchRellErrorString(rellError) {
    const parsed = rellError.match(/\[([^\]]+)\]\sOperation\s'([^']+)'\sfailed:\s(.+)$/);
    if (!parsed)
        return {};
    const [rellLine, operation, shortReason] = parsed.slice(1);
    return { shortReason, rellLine, operation };
}
//# sourceMappingURL=formatter.js.map